import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { N8N_INGEST_RUNS_QUERY_KEY } from '@/config/appSettingsKeys'

export const N8N_INGEST_IDEMPOTENT_FILES_QUERY_KEY = ['n8n-ingest-idempotent-files'] as const

export interface N8nIngestIdempotentFile {
  src_file_id: string
  src_file_name: string | null
  stream: string | null
  ingest_type: string
  folder_key: string | null
  last_item_id: string
  last_run_id: string
  last_finished_at: string | null
  accessibility_upload_id: string | null
  streaming_ingest_run_id: string | null
  rows_inserted: number | null
}

export function useN8nIngestIdempotentFiles(enabled: boolean) {
  return useQuery({
    queryKey: N8N_INGEST_IDEMPOTENT_FILES_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_n8n_ingest_idempotent_files')
      if (error) throw error
      return (data ?? []) as N8nIngestIdempotentFile[]
    },
    enabled,
    staleTime: 30_000,
  })
}

export function useResetN8nIngestFileIdempotency() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (srcFileId: string) => {
      const { data, error } = await supabase.rpc('reset_n8n_ingest_file_idempotency', {
        p_src_file_id: srcFileId,
      })
      if (error) throw error
      return Number(data ?? 0)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: N8N_INGEST_IDEMPOTENT_FILES_QUERY_KEY })
      void queryClient.invalidateQueries({ queryKey: N8N_INGEST_RUNS_QUERY_KEY })
    },
  })
}
